import {Delete, GET, POST} from "../util";

const queryfilterApi = {
  getFilterGroup: (type) => {
    return GET(`api/query-filters/filters/${type}`);
  },
  addFilterGroup: (params = {}) => {
    return POST(`api/query-filters/add`, params);
  },
  editFilterGroup: (params = {}) => {
    return POST(`api/query-filters/edit`, params);
  },
  deleteFilterGroup: (id) => {
    return Delete(`api/query-filters/delete/${id}`);
  },
};
export { queryfilterApi };
